
import './App.css';
import { LinuxCafe } from './LinuxCafe';

window.profile = 0
function App() {
  return (
    <div className="App">
    <LinuxCafe />
    </div>
  );
}

export default App;
